import { labelMatcher } from './label-mapper';

const buildDataObject = (entryValue, stats) => {
  return [
    {
      type: 'main',
      value: entryValue,
      ...stats.classificationMinMax,
    },
    {
      type: 'median',
      area: 'entityCategory',
      min: stats.classificationMinMax.min,
      max: stats.classificationMinMax.max,
      ...stats.classificationMedian,
    },

    { type: 'text', ...stats.stateMinAndMax },
  ];
};

const buildDataComparisonObject = (entryValue, stats) => {
  const globalScale = stats.classificationMinMax;
  return [
    {
      type: 'main',
      value: entryValue,
      ...globalScale,
    },
    {
      type: 'compared',
      legendHidden: true,
      value: stats.valueToCompare,
      ...globalScale,
    },
    { type: 'text', ...stats.classificationMinMax },
  ];
};

const getStats = (councilData, entryAttribute, subEntryAttribute) => {
  const classificationMinMax = getMinMax(
    councilData.classification,
    entryAttribute,
    subEntryAttribute
  );
  const stateMinAndMax = getMinMax(
    councilData.state,
    entryAttribute,
    subEntryAttribute
  );

  const classificationMedian = getMedian(
    councilData.classification,
    entryAttribute,
    subEntryAttribute
  );

  return {
    classificationMinMax,
    stateMinAndMax,
    classificationMedian,
  };
};

const getComparisonStats = (councilData, entryAttribute, subEntryAttribute) => {

  const classificationMinMax = getMinMax(
    councilData.classification,
    entryAttribute,
    subEntryAttribute
  );

  const stateMinAndMax = getMinMax(
    councilData.state,
    entryAttribute,
    subEntryAttribute
  );

  const valueToCompare = subEntryAttribute
    ? councilData.comparedEntity[entryAttribute][subEntryAttribute]
    : councilData.comparedEntity[entryAttribute];

  return {
    classificationMinMax,
    stateMinAndMax,
    valueToCompare,
  };
};

const getMedian = (dataArray, entryAttribute, subEntryAttribute) => {
  const dataArrayByAttribute = dataArray.map(el => {
    return subEntryAttribute
      ? el[entryAttribute][subEntryAttribute]
      : el[entryAttribute];
  });
  return computeMedian(dataArrayByAttribute);
};

const getMinMax = (dataArray, entryAttribute, subEntryAttribute) => {
  var min = null,
    max = null;
  const isTextLookup = {
    High: true,
    Moderate: true,
    Lower: true,
  };

  // <dan>
  const filteredArray = dataArray.filter(elem => elem !== undefined)

  const firstCouncil = filteredArray[0];
  const firstValue = subEntryAttribute
    ? firstCouncil[entryAttribute][subEntryAttribute]
    : firstCouncil[entryAttribute];
  if (isTextLookup[firstValue]) {
    return {
      min: 'Lower',
      max: 'High',
      trueMin: 'Lower',
    };
  }

  filteredArray.forEach(council => {
    const entryValue = subEntryAttribute
      ? council[entryAttribute][subEntryAttribute]
      : council[entryAttribute];

    if (!min && !max) {
      min = entryValue;
      max = entryValue;
    } else {
      if (entryValue < min) {
        min = entryValue;
      }
      if (entryValue > max) {
        max = entryValue;
      }
    }
  });

  return {
    min: Math.min(0, min),
    max: max,
    trueMin: min,
  };
};

export const dataComparisonMapper = councilData => {

  return Object.entries(councilData.activeEntity).map(
    ([entryAttribute, entryValue]) => {
      var data = {};
      var subCategories = null;

      if (typeof entryValue === 'object') {
        subCategories = Object.keys(entryValue).map(entryName => {
          return {
            value: entryName,
            label: labelMatcher(entryName),
          };
        });

        Object.entries(entryValue).forEach(
          ([subEntryAttribute, subEntryValue]) => {
            const stats = getComparisonStats(
              councilData,
              entryAttribute,
              subEntryAttribute
            );
            data[subEntryAttribute] = buildDataComparisonObject(
              subEntryValue,
              stats
            );
          }
        );
      } else {
        const stats = getComparisonStats(councilData, entryAttribute);
        data = buildDataComparisonObject(entryValue, stats);
      }

      return {
        title: labelMatcher(entryAttribute),
        subCategories: subCategories,
        key: entryAttribute,
        data: data,
      };
    }
  );
};

export const dataMapper = entityData => {

  // <dan>
  if (!entityData.activeEntity) {
    console.log("No active entity", entityData);
    return entityData;
  }

  //For every attributes of the councilData object
  return Object.entries(entityData.activeEntity).map(
    ([entryAttribute, entryValue]) => {
      var data = {};
      var subCategories = null;

      //if there is a sub object
      // eg: rateAndAnnualCharges: {
      //   total: ...,
      //   ordinaryRates: ...
      //   etc...
      // }
      if (typeof entryValue === 'object') {
        //SubCategory array is filled with the sub object attributes so we can pick them in a select dropdown
        //eg: [
        //  {value: "total", label: "total"},
        //  {value: "ordinaryRates", label: "ordinary rates"}
        // ]
        subCategories = Object.keys(entryValue).map(entryName => {
          return {
            value: entryName,
            label: labelMatcher(entryName),
          };
        });
        // Data is an object with attributes = subcategories
        Object.entries(entryValue).forEach(
          ([subEntryAttribute, subEntryValue]) => {
            const stats = getStats(
              entityData,
              entryAttribute,
              subEntryAttribute
            );
            data[subEntryAttribute] = buildDataObject(subEntryValue, stats);
          }
        );
      } else {
        const stats = getStats(entityData, entryAttribute);
        data = buildDataObject(entryValue, stats);
      }

      const ret = {
        title: labelMatcher(entryAttribute),
        subCategories: subCategories,
        key: entryAttribute,
        data: data,
      };
      return ret;
    }
  );
};

const computeMedian = array => {
  const sortedArray = array.slice().sort(sortNumber);
  var median = 0;
  if (sortedArray.length % 2 === 0) {
    median =
      (sortedArray[sortedArray.length / 2] +
        sortedArray[sortedArray.length / 2 - 1]) /
      2;
  } else {
    median = sortedArray[(sortedArray.length - 1) / 2];
  }

  return {
    value: median,
  };
};

const sortNumber = (a, b) => {
  return a - b;
};



// WEBPACK FOOTER //
// ./src/helpers/data-mapper.js